/**
 * Marks this browser as belonging to a DNA kit buyer so the first-run intent
 * picker doesn't pull them away from registering their kit.
 */
const KIT_BUYER_KEY = 'lw_kit_buyer'

export function markKitBuyer(): void {
  try {
    localStorage.setItem(KIT_BUYER_KEY, '1')
  } catch {
    // Storage unavailable — the route-based suppression still applies.
  }
}

export function isKitBuyer(): boolean {
  try {
    return !!localStorage.getItem(KIT_BUYER_KEY)
  } catch {
    return false
  }
}

/** Clear once acted on, so a later person on the same browser isn't marked as a kit buyer. */
export function clearKitBuyer(): void {
  try {
    localStorage.removeItem(KIT_BUYER_KEY)
  } catch {
    // Storage unavailable — nothing to clear.
  }
}
